import { pb } from '@/libs/pocketbase'
import type { PermissionConfiguration, PermissionPort, PermissionUser } from '../domain/permission'

// Raw shape returned by GET /api/permissions/users
type RawPermissionUser = {
	id: string
	fullName: string
	email: string
}

const pbPermissions: PermissionPort = {
	getConfig: () =>
		pb.send<PermissionConfiguration>('/api/permissions/config', {
			method: 'GET',
			// Disable auto-cancellation so StrictMode double-invocation doesn't abort the first request.
			requestKey: null,
		}),

	saveConfig: async (config: PermissionConfiguration) => {
		await pb.send('/api/permissions/config', {
			method: 'PUT',
			body: JSON.stringify(config),
			headers: { 'Content-Type': 'application/json' },
			requestKey: null,
		})
	},

	listUsers: () =>
		pb
			.send<RawPermissionUser[]>('/api/permissions/users', { method: 'GET', requestKey: null })
			.then((users): PermissionUser[] =>
				users.map(u => ({ id: u.id, fullName: u.fullName || null, email: u.email })),
			),
}

export { pbPermissions }
